// extracted by css-extract-rspack-plugin
export default {"root":"sWxyI","libraryActions":"qqf07"};